var RepeaterDataAdapter = require("enyo-ui/RepeaterDataAdapter"),
    kind                = require("enyo/kind");

require("enyo-ui");

/**
 * [RepeaterArrayDataAdapter]{@link enyo-ui.RepeaterArrayDataAdapter} is
 * designed to let [Repeater]{@link enyo-ui.Repeater} use an Array as data
 * source.
 *
 * This is a naive implementation that simply replaces all children when data
 * changes. As such, it probably does not scale very well for large arrays or
 * complicated child components.
 *
 * @class   enyo-ui.RepeaterArrayDataAdapter
 * @extends enyo-ui.RepeaterDataAdapter
 * @public
 */
module.exports = kind(/** @lends enyo-ui.RepeaterArrayDataAdapter */ {

    /**
     * @private
     */
    name: "enyo-ui.RepeaterArrayDataAdapter",

    /**
     * @private
     */
    kind: RepeaterDataAdapter,

    /**
     * Super naive implementation, simply updates length and replaces all
     * children.
     *
     * @param {Array}  previous  The previous array
     * @public
     */
    dataChanged: function() {
        var repeater = this.repeater,
            data     = repeater.data || [];

        // First change properties derived from data
        repeater.set("length", data.length);

        // Then prune the DOM
        repeater.destroyChildren();

        // Reflow the repeater, in case the arranger wants to do anything
        // predictive based on the new dataset.
        repeater.reflowOnDataChange && repeater.reflow();

        // Finally, update the DOM
        if (repeater.length && repeater.hasNode()) {
            repeater.draw();
        }
    },

    /**
     * Gets a record from the dataset by index.
     *
     * @param  {number}  index  The index
     * @return {*}       The record, or `null` if not found.
     * @public
     */
    getRecordByIndex: function(index) {
        var data = this.repeater.data || [];

        return data[index] || null;
    },

    /**
     * Gets a record from the dataset by index.
     *
     * @param  {*}       record  The record
     * @return {number}  The index, or `null` if not found.
     * @public
     */
    getIndexByRecord: function(record) {
        var data  = this.repeater.data || [],
            index = data.indexOf(record);

        return index > -1 ? index : null;
    },

    /**
     * Gets a unique identifier for the record.
     *
     * @param  {*}       record  The record
     * @return {string}  The record uid.
     * @public
     */
    getRecordUid: function(record) {
        return String(record.id);
    },

    /**
     * This method only here to satisfy the repeater api. Because any data
     * change will trigger a complete re-draw we don't actually need to update
     * any children.
     *
     * @param  {enyo.Control}  child   The child
     * @return {enyo.Control}  The created child
     * @public
     */
    updateChild: function(child) {
        return child;
    }

});
